// @flow
import React, { PureComponent } from "react";
import classNames from "classnames";

type Props = {
  height: number,
  width: number,
  className: any
};

class Level1 extends PureComponent<Props> {
  render() {
    const { height, width, className } = this.props;
    const classes = classNames("icone", className);

    return (
      <svg className={classes} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <title>Disciplinas</title>
        <desc>Representação de 1 nível de informação</desc>
        <g id="icon-level1">
          <path d="M15,16H1a1,1,0,0,1-1-1V1A1,1,0,0,1,2,1V14H15a1,1,0,0,1,0,2Z" />
        </g>
      </svg>
    );
  }
}

export default Level1;
